import { LS_AUTH_TOKEN } from "./localstorage";

const handleSessionExpired = () => {
  // `/logout` can't clear the token itself if the rejected token keeps the
  // router from mounting, which would redirect here again on every load.
  window.localStorage.removeItem(LS_AUTH_TOKEN);
  const returnTo =
    window.location.pathname + window.location.search + window.location.hash;
  window.location.assign(`/logout?returnTo=${encodeURIComponent(returnTo)}`);
};

export default handleSessionExpired;
